<template>
  <div class="col-12 flex items-center mt2 mb3">
    <span class="mr2">Appliquer Prorata ?</span>
    <SwitchComponent v-model="applyProRata" />
  </div>
</template>

<script>
import SwitchComponent from '@/components/elements/Switch.vue';

export default {
  components: { SwitchComponent },
  data () {
    return { applyProRata: !!this.$store.state.siteInfo.pro_rata };
  },
  watch: {
    applyProRata: function (newVal) {
      this.$emit('applyProRata', newVal);
    }
  }
};
</script>
